import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { appHeaderStyles } from './app-header.css';
import { renderAppHeaderPresentation, type AppHeaderProps } from './app-header-presentation';

@customElement('app-header')
export class AppHeader extends LitElement {
  static styles = [appHeaderStyles];

  render() {
    const props: AppHeaderProps = {
      name: 'Geireann Lindfield Roberts',
      location: 'Brooklyn, NY',
      github: 'https://github.com/geireann',
      linkedin: 'https://linkedin.com/in/geireann',
      email: 'geireann@alumni.brown.edu',
    };

    return renderAppHeaderPresentation(props);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'app-header': AppHeader;
  }
}
